import TowerTransitionComponent from "./TowerTransitionComponent";
const SiteOverview = () => {
    return <TowerTransitionComponent siteoverview={true} />;
};

export default SiteOverview;
